import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { Checkbox, Stack, Typography } from '@mui/material'

// Import typedefs from another file
/**
 * @typedef {import('../../generic/utilities/objectStructures/programWindow/parserSettings').ParserSettings} ParserSettings ParserSettings object
 */

/**
 * SmartSelect component
 * @param {Object} props Properties object
 * @param {ParserSettings} props.parserSettings ParserSettings object
 * @param {function(ParserSettings)} props.onChangeParserSettings Add mode by default
 */
const CamParserSettings = ({ parserSettings, onChangeParserSettings }) => {
  const { t_ } = useSmartTranslation()
  const checkBoxListValues = [
    {
      checked: parserSettings.part,
      disabled: false,
      label: t_('Part'),
      handleChange: (event) => onChangeParserSettings({ ...parserSettings, part: event.target.checked })
    },
    {
      checked: parserSettings.rawMaterial,
      disabled: false,
      label: t_('Raw Material'),
      handleChange: (event) => onChangeParserSettings({ ...parserSettings, rawMaterial: event.target.checked })
    },
    {
      checked: parserSettings.fixture,
      disabled: true,
      label: t_('Fixture'),
      handleChange: (event) => onChangeParserSettings({ ...parserSettings, fixture: event.target.checked })
    },
    {
      checked: parserSettings.tool,
      disabled: false,
      label: t_('Tool'),
      handleChange: (event) => onChangeParserSettings({ ...parserSettings, tool: event.target.checked })
    }
  ]
  return (
    <Stack direction='column' style={{ alignItems: 'start', marginTop: '1rem' }}>
      <Typography variant='h6'>{t_('Parse Resources') + ':'}</Typography>
      <Stack direction='column' style={{ alignItems: 'start', marginTop: '1rem' }}>
        {
          checkBoxListValues.map((checkBox, index) => (
            <div key={'checkBoxDiv' + index}>
              <Checkbox
                key={'checkBox' + index}
                disabled={checkBox.disabled}
                checked={checkBox.checked}
                onChange={checkBox.handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />{checkBox.label}
            </div>
          ))
        }
      </Stack>
    </Stack>
  )
}

export default CamParserSettings
